import React, { useState, useEffect } from "react";
import useHttp from '../../../hooks/use-http';
import { endPoints } from "../../../config/end-points"
import { useDispatch } from "react-redux";
import { settingAction } from "../../../store/setting-store";
import { personalizeAction } from "../../../store/pesonalize-store";

const ReviewLayerModal = ({
  setShowReviewLayerModal,setReview1Data, setShowReview1, review1Data
}) => {

  const {sendRequest: SearchBusiness} = useHttp();
  const {sendRequest: getReviews} = useHttp();
  const {sendRequest: getSummery} = useHttp();
  const dispatch = useDispatch();
  
  const {sendRequest: getSettingData} = useHttp();

  const [bname, setBname] = useState("");
  const [location, setLocation] = useState('');
  const [source , setSource] = useState('google');
  const [g_apikey, setG_apikey] = useState("");
  const [y_apikey, setY_apikey] = useState(""); 

  const [ businessResult, setBusinessResult ] = useState([]);
  const [ placeDetails, setPlaceDetails ] = useState([]);
  const [ showBusinesses, setShowBusinesses] = useState(false);
  const [ showPlaceDetails, setShowPlaceDetails] = useState(false);

  const [ yelpBusinessResult, setYelpBusinessResult ] = useState([]);
  const [ yelpPlaceDetails, setYelpPlaceDetails ] = useState([]);
  const [ showYelpBusinesses, setShowYelpBusinesses] = useState(false);
  const [ showYelpPlaceDetails, setShowYelpPlaceDetails] = useState(false);

  const [ selectedReview, setSelectedReview] = useState([]);

  const [ pageloader , setPageloader ] = useState(false);

  const [isBnameValid, setIsBnameValid] = useState(true);
  const [isLocation, setIsLocation] = useState(true);


  const hideAll = () => {
    setShowBusinesses(false);
    setShowPlaceDetails(false);
    setShowYelpBusinesses(false);
    setShowYelpPlaceDetails(false);
    setPageloader(false);

  }


  const addReview = async (review, id) => {
    console.log(selectedReview.length)
    if (selectedReview.length < 2) {
      if (!selectedReview.includes(review)) {
        lightBorder(id);
        setSelectedReview([...selectedReview, review]);
      } else {
        removeBorder(id);
        await removeReview(review);
        // console.log('This review has been removed.');
      }
    } else {
      if (selectedReview.includes(review)) {
        removeBorder(id);
        await removeReview(review);
      }
      // console.log('You can only select up to 2 reviews.');
    }
  };
  
  const removeReview = async (review) => {
    setSelectedReview(selectedReview.filter(item => item !== review));
  };

  let final_review = {
      auth_profile_url: '',
      author_name: '',
      time_description: '',
      rating: '',
      reviewText: '',
      auth_profile_url2: '',
      author_name2: '',
      time_description2: '',
      rating2: '',
      reviewText2: '',
      source_logo: '',
      source: ''
    }


  useEffect(() => {

    
    selectedReview.forEach((item, index) => {
      if(source === 'google'){
        if(index === 0){
          final_review.auth_profile_url = item.profile_photo_url || item.user.image_url;
          final_review.author_name = item.author_name || item.user.name;
          final_review.time_description = item.relative_time_description || item.time_created;
          final_review.rating = item.rating;
          final_review.reviewText = item.text;
          final_review.source_logo = 'https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/Images/google.svg';
          final_review.source = source;
          
        }else{
          final_review.auth_profile_url2 = item.profile_photo_url || item.user.image_url;
          final_review.author_name2 = item.author_name || item.user.name;
          final_review.time_description2 = item.relative_time_description || item.time_created;
          final_review.rating2 = item.rating;
          final_review.reviewText2 = item.text;
        }
      }else{
        if(index === 0){
          final_review.auth_profile_url = item.user.image_url;
          final_review.author_name = item.user.name;
          final_review.time_description = calculateTimeAgo(item.time_created);
          final_review.rating = item.rating;
          final_review.reviewText = item.text;
          final_review.source_logo = 'https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/Images/yelp.svg';
          final_review.source = source;
        }else{
          final_review.auth_profile_url2 = item.user.image_url;
          final_review.author_name2 = item.user.name;
          final_review.time_description2 = calculateTimeAgo(item.time_created);
          final_review.rating2 = item.rating;
          final_review.reviewText2 = item.text;
        }
      }
    });
    dispatch(personalizeAction.setSelectedreviewsData({ personalize_selectedreviews: final_review ,personalize_reviewSource: source}));
    console.log(selectedReview);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedReview, dispatch]);

  useEffect(() => {

    hideAll();
    dispatch(personalizeAction.setSelectedreviewsData({ personalize_selectedreviews: {} ,personalize_reviewSource: source}));
    setSelectedReview([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source, dispatch]);

  useEffect(()=>{

    
        getSettingData({
            url: endPoints.getSettingData,
            method: "GET",
        },(response)=>{
            if(response.status === 200 && response.body.length > 0){
                // console.log(response.body)
                const result = response.body
                const API_Data = result.filter((data)=>data.meta_type === "API_KEYS");
                const meta_data = JSON.parse(API_Data[0].meta_data)
                if(meta_data){
                    dispatch(settingAction.setAPIkeys({ api_keys:meta_data}));
                    setG_apikey(meta_data.googleApiKey);
                    setY_apikey(meta_data.yelpApiKey);
                }
            }
        })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

  const handleSubmit = () => {
    // console.log(bname, location, source, g_apikey, y_apikey);

    if(bname === ''){
      setIsBnameValid(false);
      return;
    }else if(location === ''){
      setIsLocation(false);
      return;
    }

    setPageloader(true);
  
    SearchBusiness({
      url: endPoints.searchBusiness,
      method: 'POST',
      body: {
        businessName: bname,
        location: location,
        source: source,
        g_apikey: g_apikey,
        y_apikey: y_apikey

      }
    }, (response) => {
      // console.log(response);
      if(response.status === 200){
        hideAll();
        if(source === 'google'){
          setBusinessResult(response.Result);
          setShowBusinesses(true);
        }else{
          setYelpBusinessResult(response.Result.businesses);
          setShowYelpBusinesses(true);
        }
        
      }
    })
    
  }

  const showReviews = (place_id) => {

    setPageloader(true);
    
    if(source === 'google'){
      SearchBusiness({
        url: endPoints.getReviews,
        method: 'POST',
        body: {
          place_id: place_id,
          g_apikey: g_apikey,
        }
      }, (response) => {
        
        if(response.status === 200){
          setPlaceDetails(response.Result);
          hideAll();
          setShowPlaceDetails(true);
        }

      })
    }else{
      getReviews({
        url: endPoints.getYelpReviews,
        method: 'POST',
        body: {
          business_id: place_id,
          y_apikey: y_apikey,
        }
      }, (response) => {
        if(response.status === 200){
          setYelpPlaceDetails(response.Result);
          hideAll();
          setShowYelpPlaceDetails(true);
        }
      })
    }
  }

  const removeBorder = (id) => {
    document.getElementById(id).style.border = "1px solid #d5d5d5";
  };

  const lightBorder = (id) => {
    document.getElementById(id).style.border = "1px solid #808fff";
  }

  const calculateTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
  
    const secondsPast = (now.getTime() - date.getTime()) / 1000;
    if(secondsPast < 60){
      return parseInt(secondsPast) + ' seconds ago';
    }
    if(secondsPast < 3600){
      return parseInt(secondsPast/60) + ' minutes ago';
    }
    if(secondsPast <= 86400){
      return parseInt(secondsPast/3600) + ' hours ago';
    }
    if(secondsPast > 86400){
      const day = parseInt(secondsPast/86400);
      if(day <= 30){
        return day + ' days ago';
      }
      if(day > 30){
        const month = parseInt(day/30);
        if(month <= 12){
          return month + ' months ago';
        }
        if(month > 12){
          return parseInt(month/12) + ' years ago';
        }
      }
    }
  };
  
  const handleResponse = (data) => {
    
    let new_reviewText = final_review.reviewText;
    let new_reviewText2 = final_review.reviewText2;

    if(new_reviewText.length > 340){
      new_reviewText = new_reviewText.substring(0,340) + "...";
    }
    if(new_reviewText2.length > 340){
      new_reviewText2 = new_reviewText2.substring(0,340) + "...";
    }
    
    setReview1Data({
      ...review1Data,
      summery1: data[0],
      summery2: data[1],
      summery3: data[2],
      auth_profile_url: final_review.auth_profile_url,
      author_name: final_review.author_name,
      time_description: final_review.time_description,
      rating: final_review.rating,
      reviewText: new_reviewText,
      auth_profile_url2: final_review.auth_profile_url2,
      author_name2: final_review.author_name2,
      time_description2: final_review.time_description2,
      rating2: final_review.rating2,
      reviewText2: new_reviewText2,
      source_logo: final_review.source_logo,
      source: source,
    });
    console.log(review1Data, data);
  }

  const genSummary = () => {

    let new_reviewText = final_review.reviewText;
    let new_reviewText2 = final_review.reviewText2;

    if(new_reviewText.length > 340){
      new_reviewText = new_reviewText.substring(0,340) + "...";
    }
    if(new_reviewText2.length > 340){
      new_reviewText2 = new_reviewText2.substring(0,340) + "...";
    }

    setReview1Data({
      ...review1Data,
      auth_profile_url: final_review.auth_profile_url,
      author_name: final_review.author_name,
      time_description: final_review.time_description,
      rating: final_review.rating,
      reviewText: new_reviewText,
      auth_profile_url2: final_review.auth_profile_url2,
      author_name2: final_review.author_name2,
      time_description2: final_review.time_description2,
      rating2: final_review.rating2,
      reviewText2: new_reviewText2,
      source_logo: final_review.source_logo,
      source: source
    });
    
    
    getSummery({
      url: endPoints.getSummery,
      method: 'POST',
      body: {
        reviewText: final_review.reviewText,
        reviewText2: final_review.reviewText2,
        source: source
      }
    }, (response) => {
      if(response.status === 200){

        handleResponse(response.data);

      }
    })

    setShowReviewLayerModal(false);
    setShowReview1(true);
    
  };


  return (
    <div  className="modal fade show d-block"  id="modalcreatevideo"  tabIndex="-1"  role="dialog"  aria-labelledby="modalcreatevideoTitle"  aria-hidden="true" >
      <div
        className="modal-dialog modal-dialog-  modal-xl"
        role="document"
      >
        <div className="modal-content" style={{minHeight:"500px"}}>
          <div className="modal-header">
            <h3>Add Review</h3>
            <button
              type="button"
              className="close"
              onClick={() => {  setShowReviewLayerModal(false); }}
            >
              <i className="fas fa-times" style={{ fontSize: "20px", color: "#cacccf" }} ></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
                <div className="col-4">
                
                  <label className="mt-4" htmlFor="text-input">Enter Your Business Name:</label>
                  <input
                    type="text"
                    id="text-input"
                    name="bname"
                    placeholder="Enter Your Business Name"
                    value={bname}
                    onChange={(e) => {
                      setIsBnameValid(true)
                      setBname(e.target.value)
                    } }
                    className={`form-control mt-3 mb-5 ${isBnameValid ? '' : 'is-invalid'}`}
                  />
                </div>
                <div className="col-4">
                  <label className="mt-4" htmlFor="text-input">Enter Your Location:</label>
                  <input
                    className={`form-control mt-3 mb-5 ${isLocation ? '' : 'is-invalid'}`}
                    type="text"
                    name="location"
                    placeholder="Enter Your Location"
                    id="text-input"
                    value={location}
                    onChange={(e) => { 
                      setLocation(e.target.value)
                      setIsLocation(true)
                    } }
                  />

                  
                  </div>
                <div className="col-4">
                  <label className="mt-4" htmlFor="text-input">Select Source:</label>
                  <div className="select-wrapper">
                    <select
                      className="form-control mt-3 mb-5"
                      id="text-input"
                      value={source}
                      onChange={(e) => setSource(e.target.value)}
                    >
                      <option value="google">Google</option>
                      <option value="yelp">Yelp</option>
                    </select>
                  </div>

                </div>
                <div className="col-12 d-flex justify-content-center">
                <button className="btn btn2" onClick={handleSubmit}> Search </button> 
                </div>
            </div>
            <div className="container position-relative" style={{minHeight:"200px",}}>  
              { showBusinesses && businessResult.length > 0 &&  (
                <div className="row mt-5">
                  <h3 className="mb-4">Search Result</h3>
                  {businessResult.map((business, index) => (
                    <div className="col-md-4" key={index} >
                      <div className="card mb-4">
                        {business.photos && business.photos.length > 0 && (
                          <img className="card-img-top" src={`https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&photoreference=${business.photos[0].photo_reference}&key=${g_apikey}`} alt={business.name} />
                        )}
                        <div className="card-body">
                          <h5 className="card-title">{business.name}</h5>
                          <p className="card-text">{business.vicinity}</p>
                          <p className="card-text">Rating: {business.rating}</p>
                          <p className="card-text">Total reviews: {business.user_ratings_total}</p>
                          <div className="d-flex justify-content-end">
                            <button className="btn btn2" onClick={() => showReviews(business.place_id)}> Show Reviews </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              { showPlaceDetails  &&  (
                <div className="row mt-5">
                  <h3 className="mb-4">Select Any 2 Reviews: </h3>
                  <div className="col-md-12 d-flex justify-content-end">
                    <button className="btn btn2 mb-2" onClick={ ()=> {
                      setShowPlaceDetails(false);
                      setShowBusinesses(true); } 
                      } >Back</button>
                  </div>

                  {placeDetails.reviews.map((reviews, index) => (
                    <div className="col-md-12 " key={index}  >
                      <div className="card mb-4 position-relative" id={`reviewDiv${index}`} onMouseEnter={ () => lightBorder('reviewDiv'+index)} onMouseLeave={ () => removeBorder('reviewDiv'+index)} onClick={ ()=>addReview(reviews, 'reviewDiv'+index) }>
                        <div className="d-flex p-2">
                          <img className="card-img-top" src={reviews.profile_photo_url} alt={reviews.author_name} style={{height: '50px',width: '50px', objectFit: 'cover'}} />
                          <h5 className="card-title mx-3 pt-3">{reviews.author_name}</h5>
                        </div>
                        <div className="card-body">
                          <p className="card-text">{reviews.text}</p>
                          <p className="card-text">Rating: {reviews.rating}</p>
                          <p className="card-text">Time: {reviews.relative_time_description}</p>
                        </div>
                        {selectedReview.includes(reviews) && <span className="tick-mark">&#10003;</span>}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {showYelpBusinesses && yelpBusinessResult.length > 0 &&  (
                <div className="row mt-5">
                <h3 className="mb-4">Yelp Search Result</h3>
                {yelpBusinessResult.map((business, index) => (
                  <div className="col-md-4" key={index}>
                    <div className="card mb-4">
                      {business.image_url && (
                        <img className="card-img-top" src={business.image_url} alt={business.name} />
                      )}
                      <div className="card-body">
                        <h5 className="card-title">{business.name}</h5>
                        <p className="card-text">{business.location.display_address.join(', ')}</p>
                        <p className="card-text">Rating: {business.rating}</p>
                        <p className="card-text">Total reviews: {business.review_count}</p>
                        <div className="d-flex justify-content-end">
                            <button className="btn btn2" onClick={() => showReviews(business.id)}> Show Reviews </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              )}

              { showYelpPlaceDetails  &&  (
                <div className="row mt-5">
                  <h3 className="mb-4">Select Any 2 Reviews: </h3>
                  <div className="col-md-12 d-flex justify-content-end">
                    <button className="btn btn2 mb-2" onClick={ ()=> {
                      setShowYelpPlaceDetails(false);
                      setShowYelpBusinesses(true); } 
                      } >Back</button>
                  </div>

                  {yelpPlaceDetails.reviews.map((reviews, index) => (
                    <div className="col-md-12 " key={index}  >
                      <div className="card mb-4 position-relative" id={`reviewDiv${index}`} onMouseEnter={ () => lightBorder('reviewDiv'+index)} onMouseLeave={ () => removeBorder('reviewDiv'+index)} onClick={ ()=>addReview(reviews, 'reviewDiv'+index) }>
                        <div className="d-flex p-2">
                          <img className="card-img-top" src={reviews.user.image_url} alt={reviews.user.name} style={{height: '50px',width: '50px', objectFit: 'cover'}} />
                          <h5 className="card-title mx-3 pt-3">{reviews.user.name}</h5>
                        </div>
                        <div className="card-body">
                          <p className="card-text">{reviews.text}</p>
                          <p className="card-text">Rating: {reviews.rating}</p>
                          <p className="card-text">Time: {reviews.time_created}</p>
                        </div>
                        {selectedReview.includes(reviews) && <span className="tick-mark">&#10003;</span>}
                      </div>
                    </div>
                  ))}
                </div>
              )}


              {pageloader && (
                  <div className="loader3">
                    <div className="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
              )}
            


              {selectedReview.length === 2 && (
                <div className="col-12 d-flex justify-content-center">
                  <button className="btn btn2" 
                  onClick={genSummary}> USE </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewLayerModal;
